import { createBrowserRouter, RouterProvider } from 'react-router';
import { THEME_ID as MATERIAL_THEME_ID, createTheme, ThemeProvider } from '@mui/material/styles';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { getRoutes } from 'src/app/AppRoutes';

import NotificationSnackbar from 'src/features/notifications/NotificationSnackbar';

const materialTheme = createTheme({
    cssVariables: true,
    palette: {
        primary: {
            main: '#06227D', // admi blue
        },
        secondary: {
            main: '#FFE53C', // admi yellow
        },
    },
    typography: {
        fontFamily: [
            'DM Sans',
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Helvetica',
            'Arial',
            'sans-serif',
            'Apple Color Emoji',
            'Segoe UI Emoji',
            'Segoe UI Symbol',
        ].join(','),
    },
});

export default function App() {
    return (
        <ThemeProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
            <JoyCssVarsProvider>
                <CssBaseline enableColorScheme />
                <RouterProvider router={createBrowserRouter(getRoutes())} />
                <NotificationSnackbar />
            </JoyCssVarsProvider>
        </ThemeProvider>
    );
}
